export function isReadOnlyUser(user) {
  if (!user) return false;
  if (user.role === 'admin' || user.isSuperAdmin) return false;
  if (user.ownedCompanies?.length > 0) return false;
  return (user.employeeOf || []).some((e) => e.role === 'viewer');
}

export function isViewerHome(user) {
  return isReadOnlyUser(user);
}
